import { http } from "src/axios";

export interface MigrateVendorResult {
  AFFECTED_STORE_COUNT: number;
  MIGRATION_REQUEST_IDS: string[];
}

export async function migrateVendor(vendorId: string | number): Promise<MigrateVendorResult> {
  const response = await http.post<{ data: MigrateVendorResult }>(`/api/v2/vendors/${vendorId}/migration-requests`);
  return response.data.data;
}
